// Core
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Components
import { FieldSelect, SectionCard } from "components/AtomsV2";
import { Icon } from "components/ShellV2";

// Redux
import { useSelector } from "react-redux";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";
import { selectAllMeters, useGetMetersByCommunityIdQuery } from "state/meters/metersApiSlice";

function MetersInfo({ data, onUpdate }) {
  const community = useSelector(selectCurrentCommunity);

  const { meters } = useGetMetersByCommunityIdQuery(
    { communityId: community.id, excludeDeleted: "true" },
    {
      selectFromResult: ({ data: metersData }) => ({
        meters: metersData && selectAllMeters(metersData),
      }),
    }
  );

  const { t } = useTranslation(["resources"]);

  const meterOptions = meters?.map((m) => ({ value: m.id, label: m.identifier })) ?? [];

  return (
    <SectionCard id="meters" icon="electric_meter" title={t("single.meters.title")}>
      <p className="text-[12.5px] text-ink-3 leading-[1.5] -mt-2 mb-4">
        {t("single.meters.question")}
      </p>
      <div className="rec-toggle-row">
        <span className="flex-1 text-[13.5px] font-semibold text-ink">
          {t("single.meters.identifier")}
        </span>
        <div className="min-w-[220px]">
          <FieldSelect
            value={data?.id ?? ""}
            options={[
              { value: "", label: t("single.meters.none", { defaultValue: "Nenhum" }) },
              ...meterOptions,
            ]}
            onChange={(v) => v && onUpdate({ meterId: v })}
          />
        </div>
        <button
          type="button"
          className="rec-icon-btn !w-[34px] !h-[34px]"
          style={{ color: "var(--danger)" }}
          title={t("single.meters.remove", { defaultValue: "Remover contador" })}
          onClick={() => onUpdate({ meterId: "TO_REMOVE" })}
        >
          <Icon name="delete" style={{ fontSize: 19 }} />
        </button>
      </div>
    </SectionCard>
  );
}

MetersInfo.defaultProps = {
  data: {
    id: "",
    identifier: "",
  },
};
MetersInfo.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    identifier: PropTypes.string,
  }),
  onUpdate: PropTypes.func.isRequired,
};

export default MetersInfo;
